<template>
  <div class="menu-wrap">
    <!-- 一级菜单 -->
    <el-menu-item
      :index="item.path"
      v-if="!item.children || item.children.length === 0"
    >
      <span slot="title">{{ item.title }}</span>
    </el-menu-item>
    <!-- 二级菜单 -->
    <el-submenu :index="item.path" v-else>
      <template slot="title">
        <span>{{ item.title }}</span>
      </template>
      <!-- 再循环一遍，这时候循环的对象就是item的children，看有没有三级菜单 -->
      <sidebar-item
        v-for="childItem in item.children"
        :key="childItem.path"
        :item="childItem"
      />
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.el-menu-item {
  height: 46px;
  line-height: 46px;
  &:hover {
    background: none !important;
    color: #4190e6 !important;
  }
  &.is-active {
    background: #4190e6 !important;
    color: #fff !important;
  }
}
::v-deep .el-submenu__title {
  &:hover {
    background: none !important;
    color: #4190e6 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/leftMenu/SidebarItem.vue